export * from './registration-error-page.component';
